import { BackdropLoader, SimpleModal, toast } from '@livable/saas-react-components';
import { Typography, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const DeactivateMemberModal = observer(_ref => {
  let isOpen = _ref.isOpen,
    handleClose = _ref.handleClose,
    member = _ref.member,
    handleDeactivateSuccess = _ref.handleDeactivateSuccess;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleClick = async () => {
    const disableTeamMemberResp = await store.teamMembers.disableTeamMemberAsync.run({
      teamMemberId: member.id
    });
    if (!disableTeamMemberResp || !disableTeamMemberResp.isSuccessful) return;
    toast('success', {
      body: ['Successfully deactivated']
    });
    handleDeactivateSuccess();
    handleClose();
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: null,
    isOpen: isOpen,
    handleClose: handleClose,
    title: t('team_page.deactivate_team_member'),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      onClick: handleClick,
      variant: "priority",
      'custom-attribute': '828-team-settings-page-deactivate-member-modal'
    }, t('team_page.deactivate'))
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('team_page.you_are_about_to_deactivate', {
    firstName: member.firstName,
    lastName: member.lastName
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('team_page.deactivate_team_member_content'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.teamMembers.disableTeamMemberAsync.inProgress
  }));
});